import { io } from "socket.io-client";
import { socketURL } from "./config";

// Notification socket for the authenticated app shell. It is a singleton so
// every screen shares one connection, but it does NOT auto-connect on import —
// call `connectNotificationSocket()` once the user is authenticated (see
// layout/Frame.js) and `disconnectNotificationSocket()` when the shell unmounts.
export const socket = io(socketURL, {
  autoConnect: false,
  // Bound the reconnection so an unreachable server backs off and eventually
  // gives up instead of retrying forever — endless retries flood the console
  // and leak memory in Chrome.
  reconnection: true,
  reconnectionAttempts: 5,
  reconnectionDelay: 1000, // start backoff at 1s
  reconnectionDelayMax: 10000, // cap exponential backoff at 10s
  timeout: 10000, // per-attempt connection timeout
});

// Surface a connection failure at most once per attempt cycle (reset on a
// successful connect). Logging only the message — never the full error object,
// re-logging which on every retry is what bloats Chrome's memory.
let connectErrorLogged = false;

socket.on("connect", () => {
  connectErrorLogged = false;
});

socket.on("connect_error", (err) => {
  if (!connectErrorLogged) {
    connectErrorLogged = true;
    console.warn("Notification socket connect_error:", err?.message);
  }
});

// Open the connection with the current auth token. Safe to call repeatedly —
// no-ops if already connected. The token is refreshed on each connect so a
// re-login uses the new credentials.
export const connectNotificationSocket = () => {
  if (socket.connected) return socket;
  const token = localStorage.getItem("__wasteknot");
  socket.io.opts.extraHeaders = { Authorization: token };
  socket.connect();
  return socket;
};

// Tear the connection down (e.g. on logout / app-shell unmount).
export const disconnectNotificationSocket = () => {
  socket.disconnect();
};
